import { render, staticRenderFns } from "./ImportResultCard.vue?vue&type=template&id=1dfda954&"
import script from "./ImportResultCard.vue?vue&type=script&lang=js&"
export * from "./ImportResultCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportResultCard.vue?vue&type=style&index=0&id=1dfda954&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports